
import {
  Vue, Component, Prop, Ref, Watch, Inject,
} from 'vue-property-decorator';
import { InputValidationRules } from 'vuetify';
import { getPostalCodeRules, stripUnoCharFromPostalCode } from '@/features/common/helpers/validationRules';
import { CountryInfo, VTextField } from '@/features/common/types';
import { CreateShipmentValidationState } from '@/features/shipment/helpers/createShipmentValidation';

@Component
export default class InputPostalCode extends Vue {
  @Inject({
    from: 'createShipmentValidationState',
    default: () => ({ attempted: true }),
  })
  private createShipmentValidationState!: CreateShipmentValidationState;

  @Prop({ required: true }) value!: string;

  @Prop({ required: false, default: '' }) countryCode!: string;

  @Prop({ required: false, default: '' }) rules!: InputValidationRules;

  @Prop({ required: false, default: '' }) id!: string;

  @Prop({ required: false, default: false }) clearable!: boolean;

  @Prop({ required: false, default: true }) outlined!: boolean;

  @Ref('postalCodeInput') postalCodeInput!: HTMLFormElement;

  get currentCountry(): CountryInfo | undefined {
    return this.$store.getters.getCountryFromCode(this.countryCode);
  }

  private getPostalCodeRules(): InputValidationRules {
    if (!this.createShipmentValidationState.attempted) return [];
    if (!this.currentCountry) return this.rules;

    return getPostalCodeRules(this.currentCountry);
  }

  @Watch('currentCountry')
  private validatePostalCodeInput() {
    this.$nextTick(() => {
      (this.$refs.postalCodeInput as VTextField).validate();
    });
  }

  private updatePostalCode(val: string) {
    this.$emit('input', val && val.toUpperCase());
  }

  private stripUnoCharFromPostalCode() {
    this.$emit('input', stripUnoCharFromPostalCode(this.value));
    this.$emit('focusout', this.validatePostalCode());
  }

  private validatePostalCode() {
    const rules = this.getPostalCodeRules();

    return rules.every((rule) => {
      if (typeof rule !== 'string') {
        const output = rule(this.value);
        return output === true;
      }
      return true;
    });
  }
}
